import type { VenueId } from '@beat-venues/common-types';
import { type VariantProps, cva } from 'class-variance-authority';
import type { ReactNode, JSX } from 'react';
import { twMerge } from 'tailwind-merge';

import { Container, Flock } from '../../';
import type { CommonProps } from '../../types';

export interface FlocksProps
    extends CommonProps,
        VariantProps<typeof FlocksStyles> {
    venue: VenueId;
    composition?: 'default' | 'footer' | 'home';
    children?: ReactNode;
}

export const FlocksStyles = cva('relative hidden xl:block -z-10');

export const Flocks = ({
    className,
    venue,
    composition = 'default',
    testId = 'flock-composition',
    children,
}: FlocksProps): JSX.Element => {
    return (
        <div className="overflow-hidden" data-testid={testId}>
            {composition === 'footer' ? (
                <Container
                    className={twMerge(
                        FlocksStyles({
                            className,
                        })
                    )}
                >
                    {/* Left */}
                    <Flock
                        className="left-[-78px] top-[80px] w-[120px] rotate-45"
                        venue={venue}
                    />
                    <Flock
                        className="left-[0px] top-[237px] w-[57px] rotate-[-75deg]"
                        venue={venue}
                    />
                    <Flock
                        className="left-[-29px] top-[262px] w-[542px] -rotate-45"
                        venue={venue}
                    />
                    {/* Right */}
                    <Flock
                        className="right-[-80px] top-[222px] w-[152px] translate-x-[100%] rotate-[60deg]"
                        venue={venue}
                    />
                    <Flock
                        className="right-[-227px] top-[401px] w-[57px] translate-x-[100%]"
                        venue={venue}
                    />
                </Container>
            ) : composition === 'home' ? (
                <Container className={twMerge(FlocksStyles({ className }))}>
                    {/* Left */}
                    <Flock
                        className="left-[-42px] top-[42px] w-[152px] -rotate-45"
                        venue={venue}
                    />
                    <Flock
                        className="left-[-75px] top-[236px] w-[44px] -rotate-45"
                        venue={venue}
                    />
                    <Flock
                        className="left-[-149px] top-[96px] w-[554px] -rotate-45"
                        venue={venue}
                    />
                    {/* Right */}
                    <Flock
                        className="right-[45px] top-[96px] w-[175px] translate-x-[100%]"
                        venue={venue}
                    />
                    <Flock
                        className="right-[-107px] top-[353px] w-[462px] translate-x-[100%] -rotate-45"
                        venue={venue}
                    />
                </Container>
            ) : (
                <Container className={twMerge(FlocksStyles({ className }))}>
                    {/* Left */}
                    <Flock
                        className="left-[-62px] top-[82px] w-[139px] -rotate-45"
                        venue={venue}
                    />
                    <Flock
                        className="left-[38px] top-[278px] w-[77px] -rotate-45"
                        venue={venue}
                    />
                    <Flock
                        className="left-[-185px] top-[168px] w-[508px] -rotate-45"
                        venue={venue}
                    />
                    {/* Right */}
                    <Flock
                        className="right-[-113px] top-[343px] w-[325px] translate-x-[100%] -rotate-45"
                        venue={venue}
                    />
                </Container>
            )}

            {children}
        </div>
    );
};
